<!--
  Main Navigation

  @since 2018-07-25
  @author kdydesign.kim
-->

<template>
  <q-scroll-area ref="mainMenuScroll"
                 class="bs bs-q-scroll-area bs-q-scroll-area-default bs-1depth-scroll">
    <div class="page-fixed-menu">
      <ul class="navi"
          @mouseleave="onMouseLeave">
        <li v-for="(item, idx) in menu"
            v-show="item.isUsed"
            :key="item.key"
            :class="['title', {'on': mainMenuKey === item.key || enterMenuKey === item.key}]"
            @mouseenter="onMouseEnter(item.key, $event)"
            @mousedown="onMouseDown(item.key, $event)">
          <a href="#"
             v-html="$parent.getMenuName(item)"
             :class="getMainMenuIcon(item.key)"></a>
        </li>

        <li style="padding-right: 15px; padding-bottom: 10px; position:relative;" v-if="menu">
          <q-search v-model="menuSearch"
                    placeholder="Search"
                    :no-icon="true"
                    class="bs bs-q-sm"
                    style="width:100%;">
            <q-autocomplete :static-data="{field: 'name', list: getSearchMenuList}"
                            :filter="searchMenuFilter"
                            custom="menuSearch"
                            :maxResults="100"
                            :customHeight="300"
                            customClass="bs bs-q-scroll-area bs-q-scroll-area-line multi-select-box-contents"
                            @blur="blurSearchMenu"
                            @selected="selectSearchMenu">
            </q-autocomplete>
          </q-search>
        </li>

        <!--Separator-->
        <li class="title divide" v-if="menu"></li>

        <!--Client Menu-->
        <li v-for="(item, idx) in clientMenu"
            :key="item.key"
            :class="['title', {'on': mainMenuKey === item.key || enterMenuKey === item.key}]"
            @mouseenter="onMouseEnter(item.key, $event)"
            @mousedown="onMouseDown(item.key, $event)">
          <a href="#"
             v-html="$parent.getMenuName(item)"
             :class="getMainMenuIcon(item.key)"></a>
        </li>

        <!--Separator-->
        <li class="title divide" v-if="isExistAlarms && isShowNav"></li>

        <li v-if="isShowNav">
          <!-- 미복구 이벤트 현황 -->
          <navigation-alarm ref="navigationAlarm"
                            @movePage="movePage"
          />

          <!-- 이벤트 티켓 현황 -->
          <ticket-event-status ref="ticketStatus"
                               @movePage="movePage"
          />

          <!-- 동기화 현황 -->
          <navigation-sync-status ref="navigationSyncStatus"
                                  @movePage="movePage"
          />
        </li>

        <!-- 개발용 -->
<!--        <li class="title divide"></li>-->
<!--        <li>-->
<!--          <nuxt-link :to="'/dev/test/embed'">Embed</nuxt-link>-->
<!--        </li>-->
      </ul>
    </div>

    <!--사용자 정보-->
    <LoginInfoPopup ref="loginInfoPopup"/>

    <confirm-dialog ref="confirmPopup"
                    :footerBtnList="confirmBtnList"
                    @onApply="onMoveMfxMgmt"/>

  </q-scroll-area>
</template>

<script>
  // 컴포넌트 Import
  import LoginInfoPopup from './LoginInfoPopup'
  // TAMS
  import NavigationAlarm from './NavigationAlarm'
  import NavigationSyncStatus from './NavigationSyncStatus'
  import TicketEventStatus from './TicketEventStatus'

  // utils
  import { newTab } from '~/utils/newWindow' // TAMS
  import { menuCodeToPath } from '~/utils/multirw'

  import {createNamespacedHelpers} from 'vuex'

  // store helper
  const
    navigationHelper = createNamespacedHelpers('common/navigation'),
    commonHelper = createNamespacedHelpers('common/common'),
    authHelper = createNamespacedHelpers('common/authenticate'),
    localeHelper = createNamespacedHelpers('common/locale')
    // vsCommonHelper = createNamespacedHelpers('virtualSystem/systemManage/common') // TAMS 제외

  export default {
    name: 'MainNavigation',
    components: {
      LoginInfoPopup,
      // TAMS
      NavigationAlarm,
      NavigationSyncStatus,
      TicketEventStatus
    },
    props: {
      // TAMS
      mainMenuKey: {
        type: String,
        default: void 0
      }
    },
    data () {
      return {
        ignoreEvent: false,
        enterMenuKey: void 0,
        isShowAdminInfo: false,
        menuSearch: '',
        menuPathMfxMgmt: void 0,
        confirmBtnList: [
          {text: this.$tc('cmn.answer', 2), color: 'dark', type: 'no'},
          {text: this.$tc('cmn.answer', 1), color: 'primary', type: 'apply'}
        ]
      }
    },
    computed: {
      ...navigationHelper.mapState([
        'menu',
        // 알람 아이콘 권한 (미복구 이벤트 현황, 동기화 현황, 이벤트 티켓 현황)
        'authAlarm',
        'authSync',
        'ticketEvent'
      ]),
      ...navigationHelper.mapGetters([
        'clientMenu'
      ]),
      ...commonHelper.mapState({
        agentTime: state => state.agentTime,
        ccFlag: state => state.uiData ? state.uiData.system.cc_flag : 1,
        newWindows: state => state.newWindows,
        isShowNav: state => state.isShowNav
      }),
      ...authHelper.mapState([
        'authToken',
        'authIssueDate',
        'authRefreshToken'
      ]),
      ...localeHelper.mapGetters([
        'getCurrentLocale'
      ]),
      alertDialog () {
        return this.$store.state.common.common.components.alertDialog
      },
      isExistAlarms () {
        try {
          return this.authAlarm || this.authSync || this.ticketEvent
        } catch (e) {
          return false
        }
      },
      getSearchMenuList () {
        let flattenMenu = _.flatten(_.map(this.menu, (dept1Menu) => {
          return _.flatten(_.map(dept1Menu.children, (dept2Menu) => {
            return _.flatten(_.map(dept2Menu.children, (dept3Menu) => {
              if (_.has(dept3Menu, 'children')) {
                return _.flatten(_.map(dept3Menu.children, (dept4Menu) => {
                  let disableFlag = false
                  if (dept4Menu.hasOwnProperty('gvRole') &&
                    ((dept4Menu.gvRole === 0 && dept4Menu.key.indexOf('groupMember') > -1) ||
                      (dept4Menu.gvRole === 1 && dept4Menu.key.indexOf('groupServer') > -1))) {
                    disableFlag = true
                  }
                  // TAMS
                  return _.assign(dept4Menu, {
                    label: dept4Menu.name,
                    sublabel: `${dept1Menu.name} > ${dept2Menu.name} > ${dept3Menu.name} > ${dept4Menu.name}`,
                    route: `${dept1Menu.key}/${dept2Menu.key}/${dept3Menu.key}/${dept4Menu.key}`,
                    disable: disableFlag
                  })
                }))
              } else {
                // TAMS
                return _.assign(dept3Menu, {
                  label: dept3Menu.name,
                  sublabel: `${dept1Menu.name} > ${dept2Menu.name} > ${dept3Menu.name}`,
                  route: `${dept1Menu.key}/${dept2Menu.key}/${dept3Menu.key}`
                })
              }
            }))
          }))
        }))

        return flattenMenu
      },
      locale () {
        return this.$store.state.common.locale.locale
      }
      // vsMode () {
      //   return this.$store.state.common.common.uiData.system.vs_mode
      // },
    },
    methods: {
      ...navigationHelper.mapActions([
        'execMfxMgmt'
      ]),
      searchMenuFilter (value, {field, list}) {
        const parseValue = value.toLowerCase().replace(/ /gi, '')

        return _.filter(list, item => item[field].toLowerCase().replace(/ /gi, '').indexOf(parseValue) > -1)
      },
      movePage (path) {
        this.$emit('movePage', path)
      },
      onMoveMfxMgmt () {
        try {
          if (this.menuPathMfxMgmt) {
            this.movePage(this.menuPathMfxMgmt)
          }
        } catch (e) {
          this.$log('Main Navigation GUI Error (onMoveMfxMgmt)', e)
        }
      },
      selectSearchMenu (item) {
        const root = '/'
        let path = ''

        if (item.hasOwnProperty('gvRole') &&
          ((item.gvRole === 0 && item.key.indexOf('groupMember') > -1) ||
            (item.gvRole === 1 && item.key.indexOf('groupServer') > -1))) {
          return
        }

        if (item.hasOwnProperty('vsType')) {
          path = `/virtualSystem/${item.vsType}/${item.route}`
          // this.$router.replace({path: `/virtualSystem/${item.vsType}/${item.route}`})
        } else {
          path = `${root}${item.route}`
          // this.$router.replace({path: `${root}${item.route}`})
        }
        this.movePage(path) // TAMS, Multi R/W 방어 코드

        this.$nextTick(() => {
          if (!this.currentMenu) {
            this.enterMenuKey = item.route.split('/')[0]

            this.$emit('changeMainMenuKey', item.route.split('/')[0])
            this.$emit('changeSubMenuKey', item.route.split('/')[0])
          } else {
            this.enterMenuKey = this.$route.matched[0].name || this.$route.path.split('/')[1]

            this.$emit('changeMainMenuKey', this.enterMenuKey)
            this.$emit('changeSubMenuKey', this.enterMenuKey)
          }

          this.$emit('changeIsSubMenu', false)

          this.menuSearch = ''
        })
      },
      blurSearchMenu () {
        this.menuSearch = ''
      },
      onMouseLeave () {
        this.enterMenuKey = null
      },
      onMouseEnter (menuKey, event) {
        if (event.target.tagName.toLowerCase() === 'li' || event.target.tagName.toLowerCase() === 'a') {
          this.enterMenuKey = menuKey
        }
      },
      // TAMS
      async onMouseDown (menuKey, event) {
        try {
          if (event.which !== 1) { // if not left button
            return
          }

          if (event.target.tagName.toLowerCase() === 'li' || event.target.tagName.toLowerCase() === 'a') {
            this.$emit('changeMainMenuKey', menuKey)
            this.$emit('changeSubMenuKey', menuKey)
            this.$emit('changeIsSubMenu', true)
          }

          const disableSubMenu = ['help', 'connUser', 'mfxSeriesMgmt', 'stic', 'wips']
          if (disableSubMenu.indexOf(menuKey) !== -1) {
            this.$emit('changeIsSubMenu', false)
          }

          if (menuKey === 'connUser') {
            this.ignoreEvent = true
            this.$refs.loginInfoPopup.show()
            document.body.addEventListener('click', this.hideAdminInfo, false)
          } else if (menuKey === 'mfxSeriesMgmt') {
            this.ignoreEvent = true
            const res = await this.execMfxMgmt()
            if (typeof res.code !== 'undefined') {
              // this.$alertPopUp.show(res.result.msg)
              if (res.code === '14040132') {
                if (this.menuPathMfxMgmt && this.menuPathMfxMgmt !== this.$route.path) {
                  this.$refs.confirmPopup.show(this.$t('msg.mfxMgmtNotRunning'))
                } else {
                  const
                    MENU_MFX_MGMT = 140401,
                    menuPath = menuCodeToPath(MENU_MFX_MGMT, this.menu)

                  if (menuPath && menuPath !== this.$route.path) {
                    this.$refs.confirmPopup.show(this.$t('msg.mfxMgmtNotRunning'))
                    this.menuPathMfxMgmt = menuPath
                  } else {
                    this.alertDialog.show(res.result.msg, 'error')
                  }
                }
              } else {
                this.alertDialog.show(res.result.msg, 'error')
              }
            }
          } else if (menuKey === 'stic') {
            this.ignoreEvent = true
            const url = 'https://stic.secui.com/'

            // window.open(url, '_blank', 'noopener')
            // TAMS, 구버전 noopener 옵션 미동작에 따른 기능 대체
            newTab(url)
          } else if (menuKey === 'help') {
            this.ignoreEvent = true
            const lang = this.$i18n.locale || 'ko'
            const url = `/help/${lang}/index.html`

            // window.open(url, '_blank', 'noopener')
            // TAMS, 구버전 noopener 옵션 미동작에 따른 기능 대체
            newTab(url)
          } else if (menuKey === 'wips') {
            this.ignoreEvent = true
            const wipsDeviceLinkPath = '/prismSystem/deviceConfig/wipsDeviceLink'
            this.movePage(wipsDeviceLinkPath)
          }
        } catch (e) {
          this.$log('Main Navigation GUI Error (onMouseDown)', e)
        }
      },
      getMainMenuIcon (key) {
        let realKey = ''

        // TODO: 추후, 메뉴 URI 재정의 후 CSS명칭을 아예 변경할 것
        // 1-depth 예외처리
        switch (key) {
          case 'prismSystem':
            realKey = 'system'
            break
          case 'analysis':
            realKey = 'threatAnalysis'
            break
          case 'docs':
            realKey = 'documents'
            break
          default:
            realKey = key
        }

        // return `menu-cursor-pointer navi-1dep-${key}`
        return `menu-cursor-pointer navi-1dep--ps-${realKey}`
      },
      hideAdminInfo () {
        if (this.ignoreEvent === true) {
          this.ignoreEvent = false
          return
        }
        this.$refs.loginInfoPopup.hide()
        document.body.removeEventListener('click', this.hideAdminInfo, true)
      }
    }
  }
</script>

<style scoped>
  @-webkit-keyframes rotating {
    from {
      -webkit-transform: rotate(360deg);
    }
    to {
      -webkit-transform: rotate(0deg);
    }
  }

  .rotating {
    -webkit-animation: rotating 2s linear infinite;
  }
  .list-inline {
    display: inline !important;
  }
  .list-inline span {
    display: inline !important;
  }

  .badge-sync {
    display: flex !important;
    flex-flow: row !important;
    justify-content: center !important;
    align-items: center !important;
    top: -1px !important;
  }
  .badge-sync .badge-icon {
    display: flex !important;
  }
</style>
